export const ManufacturerDataFragment = `
    id
    name
    image_path
    base_product_count
`
